
import React from "react";
const Modal_footer = (props) => {

  return (
    <div className="modal-footer" id="footer">
      {props.proceed &&
        (props.conditionSupported == true || props.isVariable) ? (
        <button
          type="submit"
          id="modalProceed"
          className="btn btn-primary kw-proceed"
          // onClick={handleProceed}
          style={props.isValidated ? { backgroundColor: "#2C40CE" } : { backgroundColor: "#2c40ce47" }}
          value="Proceed"
        >
          {props.ModalType.isediting == true ? "Update" : "Proceed"}
        </button>
      ) : null}
    </div>
  );
};

export default Modal_footer;
